"use client";

import { Facebook, Instagram, Twitter, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-4 justify-center">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-4 w-16 bg-muted/30 animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center text-sm">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="!text-[hsl(45,93%,47%)] hover:!text-[hsl(45,93%,47%)] transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref: logoRef,
    isVisible: logoVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: navRef,
    isVisible: navVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contactRef,
    isVisible: contactVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: socialRef,
    isVisible: socialVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: copyrightRef,
    isVisible: copyrightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer className="bg-dark-background text-foreground-dark ![padding:5px_0px_5px_0px]">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col items-center gap-8 !text-[hsl(0,0%,100%)]">
          {}
          <div ref={logoRef} className={`transition-all duration-[var(--duration-medium)] ${logoVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <img src="https://educationfamilytutors.com/wp-content/uploads/2026/01/Copy-of-New-Education-Family-Logo.png" alt="Education Family Tutors" className="!w-[150px] !h-[150px]" />
          </div>

          {}
          <div ref={navRef} className={`transition-all duration-[var(--duration-medium)] delay-100 ${navVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <MenuProvider menu_id="14">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div ref={contactRef} className={`flex flex-col sm:flex-row items-center gap-4 sm:gap-8 transition-all duration-[var(--duration-medium)] delay-200 ${contactVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <Link to="mailto:support@educationfamilytutors.com" className="flex items-center gap-2 text-foreground-dark/80 hover:text-secondary transition-colors duration-[var(--duration-fast)] text-sm">
              <Mail className="size-4" />
              <span className="!text-[hsl(45,93%,47%)]">
                support@educationfamilytutors.com
              </span>
            </Link>
            <Link to="tel:+447355792647" className="flex items-center gap-2 text-foreground-dark/80 hover:text-secondary transition-colors duration-[var(--duration-fast)] text-sm">
              <Phone className="size-4" />
              <span className="!text-[hsl(45,93%,47%)]">+44 7355 792647</span>
            </Link>
          </div>

          {}
          <div ref={socialRef} className="flex gap-6 transition-all duration-[var(--duration-medium)] delay-300 opacity-100 translate-x-0">
            <Link to="https://facebook.com/educationfamilytutors" newTab className="!text-[hsl(45,93%,47%)] hover:!text-[hsl(45,93%,47%)] transition-colors duration-[var(--duration-fast)]" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://www.instagram.com/educationfamilytutors?igsh=MWh5djdpdTEwNXZ1NA%3D%3D&utm_source=qr" newTab className="!text-[hsl(45,93%,47%)] hover:!text-[hsl(45,93%,47%)] transition-colors duration-[var(--duration-fast)]" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://twitter.com/educationfamily" newTab className="!text-[hsl(45,93%,47%)] hover:!text-[hsl(45,93%,47%)] transition-colors duration-[var(--duration-fast)]" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
          </div>

          {}
          <div ref={copyrightRef} className={`text-center text-sm text-foreground transition-all duration-[var(--duration-medium)] delay-400 ${copyrightVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <p className="!text-[hsl(45,93%,47%)]">
              Education Family Tutors © 2025 – All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}